import store from "./store";
import config from "./config"
import axios from "axios"
class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }


    upload = () => {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                var _store = store

                let obj = {};
                obj.accessToken = store.state.userInfo.accessToken;
                obj.tokenType =store.state.userInfo.tokenType;
                let formData = new FormData();
        
                formData.append('type', 'baseMap');
                formData.append('file', file);
                formData.append('lang', "en-us")
        
                  var Authorization = obj.tokenType + " " + obj.accessToken;
                  delete obj ['tokenType'];
                  delete obj ['accessToken'];
                axios
                .post(config.fileUploadUrl, formData,{
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `${Authorization}`
                    }
                })
                .then(data => {
                  if (data.data.code === 0) {
                    
                    resolve({
                        default: data.data.payload.fullName
                    });
                    // return data.data.payload.fullName;
                  }else{
                    reject('')
                  }
                })
            }));
    }
    abort = () => {
    }
}

function MyCustomUploadAdapterPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader);
    };
}

export {
    MyUploadAdapter,
    MyCustomUploadAdapterPlugin
}